import { jsx as _jsx } from "react/jsx-runtime";
import ToastProvider from './Toast/ToastProvider';
import NotificationContext from './NotificationContext';
import AlertProvider from './Alerts/AlertProvider';
import LoadingFeedbackProvider from './LoadingFeedback/LoadingFeedbackProvider';
// notification provider
const NotificationProvider = (props) => {
    // return
    return (_jsx(NotificationContext.Provider, { value: null, children: _jsx(ToastProvider, { children: _jsx(AlertProvider, { children: _jsx(LoadingFeedbackProvider, { children: props.children }) }) }) }));
};
export default NotificationProvider;
